import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

import { Button, type ButtonProps } from '../../../server/Button/Button';

export type ModalTriggerProps = ButtonProps;

export const ModalTrigger = forwardRef<HTMLButtonElement, ModalTriggerProps>((props, ref) => {
	return (
		<Dialog.Trigger asChild>
			<Button ref={ref} {...props} />
		</Dialog.Trigger>
	);
});
